export default "__VITE_ASSET__hWfC2w4T__"